import App from '@containers/Resources/ProductDocumentation/App';
import {BrowserRouter as Router, withRouter} from 'react-router-dom';
import _ScrollToTop from '@components/common/ScrollToTop';
import {Query} from 'react-apollo';
import {client} from '@core/GraphQLProvider';
import {Catalog} from '@services/ProductCatalogService/query.graphql';

const ScrollToTop = withRouter( _ScrollToTop );

export const ProductDocumentation = () =>
    <Query
        client={client}
        query={Catalog}
        variables={{
            includeAllSkus: true
        }}>
        {( {data, error, loading} ) => {

            if ( error ) {
                return <div>error</div>;
            }

            return (
                <Router basename="/resources/product-documentation">
                    <ScrollToTop>
                        <App productList={data.allProducts}/>
                    </ScrollToTop>
                </Router>
            );
        }}
    </Query>;
